import AppEmbed from '@/components/AppEmbed';
import { useQuickEdit } from '@/hooks/useQuickEdit';
import QuickEditWrapper from '@/components/quickedit/QuickEditWrapper';

interface AppEmbedSectionProps {
  section: {
    id: string;
    title?: string;
    content?: {
      app_id?: string;
      path?: string;
      height?: number;
    };
  };
}

/**
 * Homepage section that embeds a Rumio app as an iframe.
 * `content.app_id` must reference a registered app; `content.path` is the
 * path on the app (e.g., "/meal-plans") to render. AppEmbed resolves the
 * app's base_url at render time via the public `/apps/:appId` endpoint —
 * never snapshotted into CMS rows.
 */
export default function AppEmbedSection({ section }: AppEmbedSectionProps) {
  const { isActive } = useQuickEdit();
  const appId = section.content?.app_id;
  const path = section.content?.path ?? '/';
  const height = section.content?.height;

  if (!appId) return null;

  const content = (
    <section className="bg-[--bg-primary]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        {section.title && <h2 className="text-2xl font-semibold mb-4">{section.title}</h2>}
        <AppEmbed
          appId={appId}
          path={path}
          height={height}
          title={section.title ?? 'App'}
          persistPath
        />
      </div>
    </section>
  );

  if (isActive) {
    return (
      <QuickEditWrapper href={`/admin/homepage`} label="Edit app embed section">
        {content}
      </QuickEditWrapper>
    );
  }
  return content;
}
